import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { cn } from '../../lib/utils';
import { useSidebar } from '../../contexts/SidebarContext';

export function Layout() {
  const { collapsed } = useSidebar();
  
  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <div className={cn(
        "transition-all duration-300 ease-in-out",
        collapsed ? "pl-[72px]" : "pl-64"
      )}>
        <Header />
        <main className="p-6 md:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export function PageHeader({ title, description, actions, children }) {
  return (
    <div className="mb-6 md:mb-8">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="font-heading text-2xl font-bold tracking-tight sm:text-3xl">
            {title}
          </h1>
          {description && (
            <div className="mt-1 text-sm text-muted-foreground sm:text-base">
              {description}
            </div>
          )}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {children}
    </div>
  );
}

export function PageContent({ children, className }) {
  return (
    <div className={cn("animate-fade-in", className)}>
      {children}
    </div>
  );
}

export function StatsCard({ title, value, change, changeType = 'neutral', icon: Icon, className }) {
  const changeColors = {
    positive: 'text-success',
    negative: 'text-destructive',
    neutral: 'text-muted-foreground',
  };

  return (
    <div 
      className={cn(
        "stats-card rounded-xl border p-6 transition-all duration-200 hover:shadow-medium",
        className
      )}
      style={{
        backgroundColor: 'hsl(var(--kpi-bg))',
        borderColor: 'hsl(var(--kpi-border))',
      }}
    >
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium text-muted-foreground">{title}</p>
        {Icon && (
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
            <Icon className="h-5 w-5 text-primary" />
          </div>
        )}
      </div>
      <div className="mt-3">
        <p className="text-2xl font-bold tracking-tight text-foreground">{value}</p>
        {change && (
          <p className={cn("mt-1 text-sm", changeColors[changeType])}>
            {change}
          </p>
        )}
      </div>
    </div>
  );
}
